import React, {Component} from 'react';
import {connect} from 'react-redux';
import BezirkeSelect from '../containers/BezirkeSelect';
import KreiseSelect from '../containers/KreiseSelect';
import FulltextSearch from '../containers/FulltextSearch'
import HdblFilter from '../containers/HdblFilter'
import OnlineFilter from '../containers/OnlineFilter'
import OfflineFilter from '../containers/OfflineFilter'
import {BarLoader} from 'react-spinners';
import {fetchBezirke} from "../actions/bezirke";
import {fetchKreise} from "../actions/kreise";
import {changeDate} from "../actions/filters";
import Flatpickr from "react-flatpickr";
import { German } from '../../node_modules/flatpickr/dist/l10n/de.js';
import '../../node_modules/flatpickr/dist/themes/material_green.css';
import Reset from "../components/Reset";
import FachgebieteSelect from "./FachgebieteSelect";
import {fetchFachgebiete} from "../actions/fachgebiete";


class Filters extends Component {
    componentDidMount() {
        this.props.dispatch(fetchBezirke());
        this.props.dispatch(fetchKreise());
        this.props.dispatch(fetchFachgebiete());
    }

    changeDate(date, prevDate) {
        if (date === prevDate) {
            this.props.dispatch(changeDate(null))
        } else {
            this.props.dispatch(changeDate(date))
        }
    }

    resetFilter() {
        window.location.reload();
    }

    render() {

        if (window.bbvTermine && window.bbvTermine.filter === false) {
            return null
        }

        var lehrfahrten = false;
        if (window.bbvTermine && window.bbvTermine.onlyLehrfahrten === true) {
            lehrfahrten = true;
        }

        if (!this.props.ready) {
            return <div className={'termin-filter'}>
                <BarLoader/>
            </div>
        }

        var flatpickrOptions = {
            inline: true,
            minDate: 'today',
            locale: German,
            defaultDate: this.props.selectedDate,
            onChange: (selectedDates, dateStr, instance) => this.changeDate(dateStr, this.props.selectedDate),
        }

        if (this.props.events.availableDates) {
            flatpickrOptions.enable = this.props.events.availableDates;
        }

        return <div className={'termin-filter'}>
            <div className={'well'}>
                <div className={'well-title'}>Filter</div>
                <div className={'well-description'}>Sie können die Suche mit diesen Filtern genauer definieren</div>
                <div className={'vsp-2'}></div>
                <div className={'row'}>
                    <div className={'col-sm-8'}>
                        { lehrfahrten === false && <div className={'row'}>
                            <div className={'col-sm-6'}>
                                <BezirkeSelect/>
                            </div>
                            <div className={'col-sm-6'}>
                                <KreiseSelect/>
                            </div>
                        </div> }
                        <div className={'row'}>
                            <div className={'col-sm-12 mt-3'}>
                                <FachgebieteSelect/>
                            </div>
                        </div>
                        <div className={'row'}>
                            <div className={'col-sm-12 mt-3'}>
                                <FulltextSearch phrase={this.props.phrase}/>
                            </div>
                        </div>

                        <div className={'row pl-4 pr-4 pt-3'}>
                            <div className={'d-flex flex-row w-100'}>
                                <div className={'flex-fill'}>
                                    { lehrfahrten === false && <OfflineFilter/> }
                                </div>
                                <div className={'flex-fill'}>
                                    { lehrfahrten === false && <OnlineFilter/> }
                                </div>
                                <div className={'d-flex justify-content-end'}>
                                    {window.bbvTermine.filter !== false && <Reset resetFilter={this.resetFilter.bind(this)}/> }
                                </div>
                            </div>
                        </div>
                        <div className={'row pl-4 pr-4'}>
                            <div className={'d-flex flex-row w-100'}>
                                <div className={'flex-fill'}>
                                    { lehrfahrten === false && <HdblFilter/> }
                                </div>
                            </div>
                        </div>
                    </div>
                    { lehrfahrten === false &&
                        <div className={'col-sm-3'}  id={'termine-flatpicker'}>
                            <Flatpickr options={flatpickrOptions} />
                        </div>
                    }
                </div>
            </div>
        </div>
    }
}

const mapStateToProps = store => {
    if (store.bezirke.list.length > 0 && Object.keys(store.kreise.list).length > 0 && store.fachgebiete.list.length > 0) {
        return {
            ready: true,
            phrase: store.filters.phrase,
            events: store.events.list,
            date: store.filters.date,
            changeDate
        }
    }
    return {
        ready: false
    }

}

export default connect(mapStateToProps)(Filters)



// WEBPACK FOOTER //
// ./src/containers/Filters.js